import { useEffect, useRef, useState } from 'react';
import { WindowHelper } from '../util/WindowHelper';

const useBreakpointRef = ({ breakpoints, breakpointValues, direction }) => {
  const containerRef = useRef(null);
  const [breakpointIndex, setBreakpointIndex] = useState(-1);

  const onBreakpointChange = index => {
    setBreakpointIndex(index);
  };

  useEffect(() => {
    const destroyWindowWatcher = WindowHelper.watchBreakpoints(breakpoints, onBreakpointChange, direction, containerRef.current);
    return destroyWindowWatcher;
  });

  return {
    ref: containerRef,
    breakpointIndex,
    breakpointValue: breakpointIndex > -1 && breakpointValues ?
      breakpointValues[breakpointIndex] :
      null
  };
};

export default useBreakpointRef;
